import { IUsersLogListVM } from "../../models/response/IUsersLogResponse";

const initialUserLogsState: IUsersLogListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  Logs: [],
};

export default initialUserLogsState;
